import React, { useState } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function SubscriptionView({ subscription }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        View
                    </Tooltip>
                }
            >
                <img src="/images/png/view.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Name</Form.Label>
                            <p>{subscription.userId?.firstName ? subscription.userId?.firstName : "-"}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Plan Name</Form.Label>
                            <p>{subscription.planName ? subscription.planName : "Basic"}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Purchase Date (Time in UTC)</Form.Label>
                            <p>{subscription.purchaseDate ? new Date(subscription.purchaseDate).toUTCString().replace(' GMT', '') : "-"}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Expire Date (Time in UTC)</Form.Label>
                            <p>{subscription.expiryDate ? new Date(subscription.expiryDate).toUTCString().replace(' GMT', '') : "-"}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Status</Form.Label>
                            {/* <p>{subscription.status ? subscription.status : "-"}</p> */}
                            <p>{subscription.promoCodeId?.code ? 'PROMO CODE' : subscription.status}</p>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Label className='mb-0'>Email</Form.Label>
                            <p>{subscription.userId?.email ? subscription.userId?.email : "-"}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SubscriptionView